import React from "react"
import tinycolor from 'tinycolor2'

import plateStyles from './plate_styles.module.scss'

const PlayerPlate = ({ first, last, icon, team, season, teamColor1, pos, index, tableScrolled }) => {

    // colors to help readability on team badge //
    const lighten = '#ffffff'
    const darken = '#000000'

    // parse season //
    const seasonString = "'" + String(season).slice(-2)

    return (
        <div className={plateStyles.playerPlateContainer}>
            <div className={plateStyles.playerPlateIndex}>
                {index + 1 }
            </div>
            <div className={plateStyles.iconContainer} style={{
                background: tinycolor.mix(lighten, teamColor1, 17)
            }}>
                <img
                    className={plateStyles.icon}
                    src={icon}
                    alt={`${last}, ${first}`}
                />
            </div>
            <div className={plateStyles.metaContainer}>
                <div className={plateStyles.nameContainer}>
                    <p className={plateStyles.firstName}>
                        {first}
                    </p>
                    <p className={plateStyles.lastName}>
                        {last}
                    </p>
                </div>
                <div className={plateStyles.rightMeta}>
                    <p className={plateStyles.playerTeamName} style={{
                        background: tinycolor.mix(lighten, teamColor1, 10),
                        color: tinycolor.mix(darken, teamColor1, 80),
                    }}>
                        {team}
                    </p>
                    <p className={plateStyles.position}>
                        {tableScrolled ? seasonString : pos}
                    </p>
                </div>
            </div>
        </div>
    )
    
}

export default PlayerPlate




